/**
 * Created by neo on 23.08.21.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { WorkoutDayEntry, createWorkoutDayEntry } from './WorkoutDayEntry';

export type WorkoutDayConfigurationJson = {
  id: string;
  workouts: WorkoutDayEntry[];
};

export type WorkoutDayConfiguration = {
  id: string;
  workouts: WorkoutDayEntry[];
  readonly minWorkoutDurationInMinutes: number | undefined;
  readonly maxWorkoutDurationInMinutes: number | undefined;
  toJS(newId?: boolean): WorkoutDayConfigurationJson;
};

export function createWorkoutDayConfiguration(json?: Partial<WorkoutDayConfigurationJson>): WorkoutDayConfiguration {
  return makeAutoObservable({
    id: json?.id ?? UUID(),
    workouts: (json?.workouts ?? []).map((w) => createWorkoutDayEntry(w)),

    get minWorkoutDurationInMinutes(): number | undefined {
      return this.workouts.reduce(
        (agg, cycle) =>
          cycle.minWorkoutDurationInMinutes
            ? Math.min(cycle.minWorkoutDurationInMinutes, agg ?? Number.MAX_SAFE_INTEGER)
            : agg,
        undefined as number | undefined,
      );
    },

    get maxWorkoutDurationInMinutes(): number | undefined {
      return this.workouts.reduce(
        (agg, cycle) =>
          cycle.maxWorkoutDurationInMinutes
            ? Math.max(cycle.maxWorkoutDurationInMinutes, agg ?? Number.MIN_SAFE_INTEGER)
            : agg,
        undefined as number | undefined,
      );
    },

    toJS(newId: boolean = false): WorkoutDayConfigurationJson {
      return {
        id: newId ? UUID() : this.id,
        workouts: this.workouts.map((w) => ({ ...w, id: newId ? UUID() : w.id })),
      };
    },
  });
}
